import React from 'react';
import { DNAIcon, DNAIconStyleProps } from '@alucio/lux-ui';

interface DNAThumbnailOverlayIconProps extends DNAIconStyleProps {
  variant: 'cloud'
}

const ThumbnailOverlayIcon: React.FC<DNAThumbnailOverlayIconProps> = ({ variant, ...props }) => {
  switch (variant) {
    case 'cloud':
      return (
        <DNAIcon.Styled
          status="primary"
          name="cloud-slash"
          {...props}
        />
      )
    default:
      return null
  }
}

export default ThumbnailOverlayIcon;
